/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { Fragment } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Component imports
import { Tabs } from 'antd';
import UserGroupsTable from '../components/Tables/UserGroupsTable';
import UserInvitationsTable from '../components/Tables/UserInvitationsTable';
import Permissioned from '../components/Permissioned';
import OrganizationUsersTable from '../components/Tables/OrganizationUsersTable';

// Misc imports
import { PERMISSIONS_GROUP_ADMIN } from '../constants/main';
import useUserPermissions from '../utils/hooks/useUserPermissions';

// Constant declarations
const { TabPane } = Tabs;

const OrganizationUsersScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const { orgId } = useParams();
  const { t } = useTranslation();
  const userPermissions = useUserPermissions(orgId, null);

  let TABS = {
    USERS: 'users',
    USER_GROUPS: 'user-groups',
    USER_INVITATIONS: 'user-invitations'
  };
  let currentTab = searchParams.get('tab') || TABS.USERS;

  const onTabChange = activeKey => {

    navigate({
      pathname: location.pathname,
      search: `?tab=${activeKey}`
    }, { replace: true });
  };

  return (
    <Fragment>
      <Permissioned
        allowedPermissions={PERMISSIONS_GROUP_ADMIN}
        currentPermissions={userPermissions}
      >
        <Tabs
          activeKey={currentTab}
          onChange={onTabChange}
          destroyInactiveTabPane
          animated={false}
          tabBarStyle={{ display: 'none' }}
        >
          <TabPane
            key={TABS.USERS}
            tab={t('Users')}
          >
            <OrganizationUsersTable />
          </TabPane>

          <TabPane
            key={TABS.USER_GROUPS}
            tab={t('User Groups')}
          >
            <UserGroupsTable />
          </TabPane>

          <TabPane
            key={TABS.USER_INVITATIONS}
            tab="User Invitations"
          >
            <UserInvitationsTable />
          </TabPane>
        </Tabs>
      </Permissioned>
    </Fragment>
  );
};

export default OrganizationUsersScreen;
